const CustomGoogleOverlay = function(bounds, el, map, pxOffset = {x: 0, y: 0}) {
  this.bounds_ = bounds;
  this.el_ = el;
  this.pxOffset = pxOffset;

  this.map_ = map;
  this.setMap(map);
  this.drawTimeout = null;

  this.draw = function(arg) {
    let inBounds = this.map_.getBounds().contains(this.bounds_.getCenter());

    if(inBounds){
      this.drawTimeout = setTimeout(() => {
      let overlayProjection = this.getProjection();

      let sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
      let ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());

      this.el_.style.left = (sw.x + this.pxOffset.x) + 'px';
      this.el_.style.top = (ne.y + this.pxOffset.y - this.el_.offsetHeight) +'px';
    }, 0);
    }
  };

  this.onAdd = function() {
    this.el_.style.position = 'absolute';

    this.getPanes().overlayLayer.appendChild(this.el_);
  };
};


export default CustomGoogleOverlay;